module.exports = __webpack_public_path__ + "img/05.1f666857.png";